import React, { useState } from "react";

// FAQ data array to separate content from presentation
const faqData = [
  {
    question: "Quel est l'espace nécessaire ?",
    answer: (
      <>
        <span className="font-bold">Poulet :</span> Que le poulailler soit en bois ou en plastique, on peut mettre jusqu'à 16 poules par m². Le mieux est tout de même de compter jusqu'à 10 pondeuses maximum par m² dans l'abri, pour que les poules s'y sentent bien et pondent des œufs régulièrement. <br />
        <span className="font-bold">Mouton :</span> Comptez un hectare de prairie pour maximum 10 brebis et leurs agneaux. Vous disposez ainsi de l'espace nécessaire pour les changer de prairie.
      </>
    )
  },
  {
    question: "Quelle est leur alimentation ?",
    answer: "Les moutons se nourrissent principalement de foin, d'herbe fraîche et de compléments alimentaires pour assurer leur santé. Nous veillons à ce qu'ils aient toujours accès à de l'eau propre. \nLes volailles se nourrissent principalement de granulés formulés, de grains, de légumes et de restes de cuisine. Nous veillons à ce qu'elles aient toujours accès à de l'eau fraîche."
  },
  {
    question: "Quels sont les soins de santé nécessaires ?",
    answer: "Les moutons doivent être régulièrement vermifugés et vaccinés. Nous faisons également des contrôles vétérinaires annuels pour assurer leur bonne santé."
  },
  {
    question: "Puis-je visiter votre ferme ?",
    answer: "Oui, nous accueillons les visiteurs sur rendez-vous. C'est une excellente occasion d'en apprendre davantage sur l'élevage de moutons."
  },
  {
    question: "Comment puis-je me lancer dans l'élevage de moutons ?",
    answer: "Nous recommandons de commencer par faire des recherches approfondies sur les races et les soins, puis de se rapprocher d'éleveurs locaux pour obtenir des conseils et des informations pratiques."
  },
  {
    question: "Quelle fréquence faut-il nettoyer l'enclos ?",
    answer: "L'enclos doit être nettoyé régulièrement, au moins une fois par semaine, pour éviter l'accumulation de fientes et de parasites."
  }
];

// Reusable FAQ Item component
const FaqItem = ({ question, answer, isOpen, onClick }) => (
  <div className="collapse collapse-plus bg-white mb-4 border border-gray-200">
    <input 
      type="radio" 
      name="faq-accordion" 
      checked={isOpen}
      onChange={onClick}
      aria-label={`Développer la question: ${question}`}
    />
    <div className="collapse-title text-xl font-medium cursor-pointer hover:bg-gray-50 transition-colors">
      {question}
    </div>
    <div className="collapse-content">
      <div className="whitespace-pre-line text-gray-700 leading-relaxed">{answer}</div>
    </div>
  </div>
);

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="py-4 max-w-4xl mx-auto px-4">
      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <FaqItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={activeIndex === index}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQs;